import axios from 'axios'
import router from '@/router'
import * as types from './types'
import { IS_REPORT_LOCKED } from '@/modules/account/store/types'
import { REPORT_HUB_ROUTE, REPORT_ROUTE } from '@/constants/appointment_report_v2'

// A chave inclui updated_at: uma versão nova (editada/republicada) do mesmo
// comunicado gera outra chave, então não é tratada como já dispensada.
const dismissedKey = (release) => `dismissed_whats_new_${release.id}_${release.updated_at || ''}`

// O auto-show do What's New cede a prioridade aos fluxos obrigatórios — só abre em
// navegação livre; enquanto bloqueado, fica pendente:
//  - trava de report pendente: getter do store (sobrevive ao recarregar a página),
//    e as próprias telas do report / central;
//  - pendência de contrato: redireciona com params.blocked = true.
const REPORT_FLOW_ROUTES = [REPORT_HUB_ROUTE, REPORT_ROUTE]
const isMandatoryFlowActive = rootGetters => !!rootGetters[IS_REPORT_LOCKED]
  || REPORT_FLOW_ROUTES.includes(router.currentRoute?.name)
  || !!router.currentRoute?.params?.blocked

export default {
  // ---- Administração ----
  [types.SEARCH_RELEASES]: ({ commit }, payload) => {
    const resource = `/api/whats-new/search?page=${payload.currentPage}`
    delete payload.currentPage
    return axios.post(resource, payload)
      .then(resp => {
        commit(types.MUTATE_WHATS_NEW_SEARCH_RESULT, resp.data)
        return Promise.resolve(resp)
      })
      .catch(err => Promise.reject(err))
  },
  [types.GET_RELEASE]: ({}, payload) => {
    return axios.get(`/api/whats-new/${payload}`)
      .then(resp => Promise.resolve(resp))
      .catch(err => Promise.reject(err))
  },
  [types.SAVE_RELEASE]: ({}, payload) => {
    let save = axios.post
    let route = '/api/whats-new'
    if (payload.id) {
      save = axios.put
      route = `/api/whats-new/${payload.id}`
    }
    return save(route, payload)
      .then(resp => Promise.resolve(resp))
      .catch(err => Promise.reject(err))
  },
  [types.DELETE_RELEASE]: ({}, payload) => {
    return axios.delete(`/api/whats-new/${payload}`)
      .then(resp => Promise.resolve(resp))
      .catch(err => Promise.reject(err))
  },
  [types.SET_RELEASE_STATUS]: ({}, payload) => {
    return axios.put(`/api/whats-new/${payload.id}/status`, { status: payload.status })
      .then(resp => Promise.resolve(resp))
      .catch(err => Promise.reject(err))
  },
  [types.UPLOAD_VIDEO]: ({}, payload) => {
    const { file, onProgress } = payload
    const form = new FormData()
    form.append('video', file)
    return axios.post('/api/whats-new/upload-video', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: event => {
        if (typeof onProgress === 'function' && event.total) {
          onProgress(Math.round((event.loaded * 100) / event.total))
        }
      },
    })
      .then(resp => Promise.resolve(resp))
      .catch(err => Promise.reject(err))
  },

  // ---- Consumo ----
  // Auto-show: busca o comunicado publicado ainda não visto e, se existir e não
  // tiver sido dispensado nesta sessão, abre o modal automaticamente.
  [types.CHECK_CURRENT_WHATS_NEW]: ({ commit, rootGetters }) => axios.get('/api/whats-new/current')
    .then(resp => {
      const release = resp.data
      if (
        release && release.id
        && !sessionStorage.getItem(dismissedKey(release))
        && !isMandatoryFlowActive(rootGetters)
      ) {
        commit(types.MUTATE_WHATS_NEW_MODAL, { visible: true, release, auto: true })
      }
      return Promise.resolve(resp)
    })
    .catch(err => Promise.reject(err)),
  // Reabertura manual: busca o último comunicado publicado (mesmo já visto).
  [types.OPEN_WHATS_NEW_MODAL]: ({ commit }) => {
    return axios.get('/api/whats-new/latest')
      .then(resp => {
        const release = resp.data
        if (release && release.id) {
          commit(types.MUTATE_WHATS_NEW_MODAL, { visible: true, release, auto: false })
        }
        return Promise.resolve(resp)
      })
      .catch(err => Promise.reject(err))
  },
  [types.CLOSE_WHATS_NEW_MODAL]: ({ commit }) => {
    commit(types.MUTATE_WHATS_NEW_MODAL, { visible: false, release: null, auto: false })
  },
  [types.GET_WHATS_NEW_HISTORY]: ({ commit }, payload) => {
    const page = (payload && payload.currentPage) || 1
    return axios.get(`/api/whats-new/history?page=${page}`)
      .then(resp => {
        commit(types.MUTATE_WHATS_NEW_HISTORY, resp.data)
        return Promise.resolve(resp)
      })
      .catch(err => Promise.reject(err))
  },
  [types.TRACK_WHATS_NEW]: ({}, payload) => {
    return axios.post(`/api/whats-new/${payload.id}/track`, {
      status: payload.status,
      items_viewed: payload.items_viewed,
    })
      .then(resp => Promise.resolve(resp))
      .catch(err => Promise.reject(err))
  },
}
